import React, { Component } from 'react';
import Moment from 'react-moment';
import {
  FaStar, FaAngleUp, FaAngleDown, FaReply,
} from 'react-icons/fa';

import { ListItem, Button, Details } from './styles';
import spacer from '../../../assets/images/spacer.png';
import avatarUrl from '../../../assets/images/default-avatar-user.png';

class Item extends Component {
  onPress = () => {
    this.props.onPressItem(this.props.id);
  };

  replyItem = () => {
    this.props.replyItem(this.props.id, this.props.item);
  }

  render() {
    const {
      date,
      clientInfo,
      storeOrderId,
      rating,
      text,
      reply,
      items,
    } = this.props.item;

    return (
      <div>
        <ListItem selected={this.props.selected}>
          <div className="row" style={{ minWidth: '180px' }}>
            <img src={avatarUrl} alt="avatar" className="avatar" />
            <h2>Nome</h2>
            <p>{clientInfo.name}</p>
          </div>
          <div className="row">
            <h2>Telefone</h2>
            <p>{clientInfo.phoneNumber}</p>
          </div>
          <div className="row">
            <h2>Nº do pedido</h2>
            <p>{storeOrderId}</p>
          </div>
          <div className="row">
            <h2>Estrelas</h2>
            <FaStar className="fa fa-star" />
            <p className="rating-text">{rating}</p>
          </div>
          <div className="row last-row">
            <h2>Enviado em</h2>
            <Moment className="date" format="DD/MM/YY [ás] HH:mm">{date}</Moment>
          </div>
          <div className="button-container">
            {!reply && (
              <Button type="submit" className="reply-btn" onClick={this.replyItem}>
                <FaReply className="fas fa-reply" />
                <span>Responder</span>
              </Button>
            )}
            <Button type="submit" onClick={this.onPress}>
              <span>Detalhes</span>
              {!this.props.selected && <FaAngleDown className="fas fa-angle-down" />}
              {this.props.selected && <FaAngleUp className="fas fa-angle-up" />}
            </Button>
          </div>
        </ListItem>
        <Details selected={this.props.selected}>
          <img src={spacer} alt="" className="spacer" />
          <div className="container">
            <div className="row">
              <p>
                <span>E-mail:</span>
                <br />
                {clientInfo.email}
              </p>
              {items.length !== 0 && (
                <p>
                  <span>Sugestões de melhorias:</span>
                  <br />
                  {items.map((item, index) => (
                    <span key={index.toString()} className="items">{item}</span>
                  ))}
                </p>
              )}
            </div>
            <div className="row">
              <p>
                <span>Comentário:</span>
                <br />
                {text}
              </p>
              {reply && (
              <p>
                <span>Resposta da loja:</span>
                <br />
                {reply.text}
              </p>
              )}
            </div>
          </div>
        </Details>
      </div>
    );
  }
}

export default Item;
